import $ from "jquery";
import "fslightbox";

$(document).on("click", ".video__start", function () {
  const wrapper = $(this).closest(".video__wrapper");
  const video = wrapper.find(".custom__video").get(0);

  // Запускаем видео
  video.play();

  // Скрываем кнопку Play
  $(this).hide();
});

// Когда видео на паузе — показываем кнопку снова
$(document).on("pause", ".custom__video", function () {
  $(this).closest(".video__wrapper").find(".video__start").show();
});

// Когда видео закончилось — возвращаем кнопку
$(document).on("ended", ".custom__video", function () {
  $(this).closest(".video__wrapper").find(".video__start").show();
});

$(".create-workshop__work_examples .examples .examples__list").each(
  (_, slider) => {
    $(slider).slick({
      // Параметры настройки слайдера
      dots: false, // Показать точки навигации
      infinite: false, // Зацикливание слайдов
      speed: 500, // Скорость перехода
      slidesToShow: 3.5, // Количество слайдов для показа
      slidesToScroll: 1, // Количество слайдов для прокрутки
      arrows: true,
      nextArrow: `<svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="slick-next"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l14 0" />
        <path d="M13 18l6 -6" />
        <path d="M13 6l6 6" />
      </svg>`,
      prevArrow: `<svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="slick-prev"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l14 0" />
        <path d="M5 12l6 6" />
        <path d="M5 12l6 -6" />
      </svg>`,
    });
  }
);

$("#exampleModal").on("show.bs.modal", function (event) {
  const button = $(event.relatedTarget); // элемент, который вызвал модалку
  const id = button.data("id");
  const name = button.data("name");
  const description = button.data("description") || "Описание отсутствует";
  const price = button.data("price") ? Number(button.data("price")) + " ₽" : "Цена не указана";
  const category = button.data("category")
  const workshopName = button.data("workshop-name")
  const workshopAvatar = button.data("workshop-avatar")
  const createdAt = button.data("created")

  let imagesRaw = button.data("images");
  let images = [];

  if (imagesRaw) {
    if (imagesRaw.result && Array.isArray(imagesRaw.result)) {
      // если структура { result: [...] }
      images = imagesRaw.result;
    } else if (Array.isArray(imagesRaw)) {
      // если сразу массив
      images = imagesRaw;
    } else if (typeof imagesRaw === "string") {
      // если строка — пробуем распарсить JSON
      try {
        imagesRaw = decodeURIComponent(imagesRaw);
      } catch (e) {
        console.warn("Ошибка decodeURIComponent:", e, imagesRaw);
      }
      try {
        const parsed = JSON.parse(imagesRaw);
        if (parsed?.result && Array.isArray(parsed.result)) {
          images = parsed.result;
        } else if (Array.isArray(parsed)) {
          images = parsed;
        }
      } catch (e) {
        console.warn("Ошибка парсинга images:", e, imagesRaw);
      }
    }
  }
  console.log("Images data:", images, button.data("images"));

  $("#exampleModalName").text(name);
  $("#exampleModalDescription").text(description);
  $("#exampleModalPrice").text(price);
  $("#exampleModalCategory").text(category);
  $("#exampleWorkshopName").text(workshopName);
  $("#exampleWorkshopAvatar").attr('src', workshopAvatar)
  $("#exampleCreatedAt").text(`Опубликовано ${createdAt}`);

  const carouselInner = $("#exampleCarouselInner");
  carouselInner.empty();

  if (images.length > 0) {
    images.forEach((src, idx) => {
      carouselInner.append(`
        <a data-fslightbox="order-gallery-${id}" href="/upload/zakaz/${src}" class="example-carousel-item ${idx === 0 ? "active" : ""}">
          <img src="/upload/zakaz/${src}" class="d-block w-100 rounded" alt="Фото работы ${
        idx + 1
      }">
        </div>
      `);
    });
    refreshFsLightbox();
  } else {
    carouselInner.append(`
      <div class="carousel-item active">
        <div class="d-flex align-items-center justify-content-center bg-light" style="height:300px;">
          <span class="text-muted">Нет фото</span>
        </div>
      </div>
    `);
  }
});
